import styled from "styled-components";

export const SMainMenuUserPopupListItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
